<ng-template #providerFilter>
	<mat-form-field appearance="standard" dense>
		<mat-select [formControl]="providerControl" i18n-placeholder placeholder="All Providers">
			<mat-select-trigger class="text-capitalize">{{providerControl.value}}</mat-select-trigger>
			<mat-option i18n>All Providers</mat-option>
			<mat-option
				*ngFor="let provider of providers"
				[value]="provider"
				class="text-capitalize"
			>{{provider}}</mat-option>
		</mat-select>
	</mat-form-field>
</ng-template>

<ng-template #clusterFilter>
	<mat-form-field appearance="standard" dense>
		<mat-select [formControl]="clusterControl" i18n-placeholder placeholder="All Clusters">
			<mat-option i18n>All Clusters</mat-option>
			<mat-option
				*ngFor="let cluster of appKeyClusters"
				[value]="cluster.clusterId"
			>{{cluster.name}}</mat-option>
		</mat-select>
	</mat-form-field>
</ng-template>

<ng-template #appKeySearch>
	<mat-form-field appearance="standard" dense class="w-100" style="padding-top: 1px;">
		<input matInput type="text" placeholder="Search" i18n-placeholder [formControl]="appKeyControl"/>
	</mat-form-field>
</ng-template>

<div class="custom-table mb-3">
    <div class="row custom-table-header">
        <div class="col-xs-auto bg- header-icon">
			<span class="material-icons">vpn_key</span>
        </div>
        <div class="col align-self-center">
            <span class="title" i18n>App Keys</span>
		</div>
		<div class="col-xs-auto mr-2 d-none d-lg-block app-key-search" *ngIf="appKeys && appKeys.length > 1">
			<ng-container *ngTemplateOutlet="appKeySearch"></ng-container>
		</div>
		<div class="col-xs-auto mr-2 d-none d-lg-block" *ngIf="providers && providers.length > 1">
			<ng-container *ngTemplateOutlet="providerFilter"></ng-container>
		</div>
		<div class="col-xs-auto mr-1 d-none d-lg-block" *ngIf="appKeyClusters && appKeyClusters.length > 1">
			<ng-container *ngTemplateOutlet="clusterFilter"></ng-container>
		</div>
        <!-- MENU -->
        <div class="col-xs-auto small-btn mr-1" *ngIf="editable">
			<button
				mat-icon-button
				type="button"
				[disabled]="loading"
				(click)="openAddAppKeyDialog()"
				matTooltip="Create an Application Access Key"
				i18n-matTooltip
				id="createAppKeyBtn"
			>
                <span class="material-icons">add_circle_outline</span>
			</button>
		</div>
		<div class="col-xs-auto small-btn d-block d-lg-none mr-1" *ngIf="(appKeysFiltered && appKeys.length > 1) || (providers && providers.length > 1) || (appKeyClusters && appKeyClusters.length > 1)">
			<button type="button" mat-icon-button [matMenuTriggerFor]="appKeyTableMenu">
                <mat-icon class="material-icons">more_vert</mat-icon>
            </button>
            <mat-menu #appKeyTableMenu="matMenu" xPosition="before">
                <div class="top-right-drop-menu">
					<div mat-menu-item *ngIf="appKeysFiltered && appKeys.length > 1" (click)="$event.stopPropagation();">
						<ng-container *ngTemplateOutlet="appKeySearch"></ng-container>
					</div>
					<div mat-menu-item *ngIf="providers && providers.length > 1" (click)="$event.stopPropagation();">
						<ng-container *ngTemplateOutlet="providerFilter"></ng-container>
					</div>
					<div mat-menu-item *ngIf="appKeyClusters && appKeyClusters.length > 1" (click)="$event.stopPropagation();">
						<ng-container *ngTemplateOutlet="clusterFilter"></ng-container>
					</div>
                </div>
            </mat-menu>
		</div>
	</div>

	<app-loader-wrapper [loading]="!appKeysFiltered || loading" size="sm" class="custom-table-body">
		<div class="row align-items-center mx-0 p-1 bordered-top custom-table-item" id="{{appkey.clientId}}" *ngFor="let appkey of appKeysPaginated; index as i" [ngClass]="{'opened': i === openedMenu, 'disabled': !appkey.valid, 'text-muted': !appkey.valid}" [matTooltip]="!appkey.valid ? 'Disabled' : ''" [matTooltipDisabled]="appkey.valid">
            <div class="col user-name text-truncate">{{ appkey.name }}</div>
            <div class="col-xs-auto small-btn">
				<!-- Client ID -->
				<button
					class="btn badge badge-pill badge-info deploy-badge mr-2 py-1 px-3 d-none d-md-inline-block border-0"
					title="Click to copy client ID"
					i18n-title
					[appCopyToClipboard]="appkey.clientId"
					[appCopyToClipboardIcon]="true"
					appCopyToClipboardVisibility="none"
				>{{appkey.clientId}}</button>
                <!-- Client ID -->
				<!-- CUSTER NAME -->
				<span
					class="badge badge-pill badge-secondary deploy-badge mr-2 py-1 px-3 text-capitalize {{ appkey.provider != 'local' ? 'badge-' + appkey.provider : '' }}"
				>{{appkey.provider}}</span>
                <!-- CUSTER NAME -->
				<span
					class="badge badge-pill badge-secondary deploy-badge mr-2 py-1 px-3"
				>{{appkey.clusterName ? appkey.clusterName : appkey.clusterId}}</span>
				<button
					class="appkey-action-menu"
					type="button"
					mat-icon-button
					[matMenuTriggerFor]="appKeyMenu"
					(menuClosed)="openedMenu = null"
					(menuOpened)="openedMenu = i"
					[disabled]="!appkey.valid"
				>
					<mat-icon class="material-icons">more_vert</mat-icon>
				</button>
				<mat-menu #appKeyMenu="matMenu">
					<button
						mat-menu-item
						i18n
						title="Edit App Key Settings"
						i18n-title
						(click)="openEditAppKeyDialog(appkey)"
						*ngIf="clusters[appkey.clusterId]"
						class="appkey-action-edit"
					>Edit Settings</button>
					<button
						mat-menu-item
						i18n
						title="Edit App Key Legals"
						i18n-title
						(click)="openAppKeyLegalsDialog(appkey)"
						class="appkey-action-legals"
					>Edit Legals</button>
					<button
						mat-menu-item
						i18n
						title="Required Versions"
						i18n-title
						(click)="openRequiredVersionsDialog(appkey)"
						class="appkey-action-required-versions"
					>View Required Versions</button>
				</mat-menu>
            </div>
        </div>

		<mat-paginator
			*ngIf="appKeys && appKeys?.length > 10"
			[length]="appKeysFiltered?.length"
			[pageSize]="pageSize"
			[pageIndex]="pageIndex"
			[pageSizeOptions]="[10, 25, 50]"
			(page)="paginateResults($event)"
		></mat-paginator>
	</app-loader-wrapper>
</div>
